import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import MeasureContent from "../../components/Measurement-comp/MeasureContent";
import MeasureNavigation from "../../components/Measurement-comp/MeasureNavigation";

const Measurement = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <Header setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <MeasureNavigation />
        </div>
        <div className="content-index">
          <MeasureContent />
        </div>
      </div>
    </div>
  );
};

export default Measurement;
